import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommunicationService } from '../../../../../services/communication.service';

@Component({
  selector: 'app-callback-text-message-platform',
  templateUrl: './callback-text-message-platform.component.html',
  styleUrls: ['./callback-text-message-platform.component.scss']
})
export class CallbackTextMessagePlatformComponent {
  public broadcastChannel = new BroadcastChannel('TEXT_MESSAGE_PLATFORM');

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private communicationService: CommunicationService,
  ) { }

  ngOnInit() {
    let PartnerID = localStorage.getItem('CommunicationPartnerID');
    let PlatformID = localStorage.getItem('CommunicationPlatformID');
    this.activatedRoute.queryParams.subscribe((params) => {
      var data = {
        PartnerID: parseInt(PartnerID),
        Code: params['code'],
        PlatformID: PlatformID,
      };
      console.log(data);
      this.communicationService.saveConfiguration(data).subscribe(
        (result) => {
          this.broadcastChannel.postMessage('CONNECTED');
          setTimeout(() => {
            window.close();
          }, 500);
        },
        (err) => {
          this.broadcastChannel.postMessage('NOT_CONNECTED');
          window.close();
        },
      );
    });
  }
}
